import React from "react";

function SubHeaderAggiorna({ titolo, funzAggiorna }) {


    return (
        <div className="tastoVerde scrittaSuFondoScuro flex items-center justify-between pl4 pr4 pt1 pb1">
            <div className="b ">{titolo}</div>
            {funzAggiorna && <div className="buttonInSubHeader flex items-center" onClick={funzAggiorna}><span className="material-icons f4 pr2">autorenew</span>Aggiorna</div>}
        </div>
    )


}

export default SubHeaderAggiorna;